var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-form-item',{attrs:{"label":"文字内部"}},[_c('avue-switch',{model:{value:(_vm.main.activeOption.position),callback:function ($$v) {_vm.$set(_vm.main.activeOption, "position", $$v)},expression:"main.activeOption.position"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }